import IonToolbar from '../../../../../components/Modal/ModalToolbar';
import { useModalAlert as useIonAlert } from '../../../../../components/Modal/ModalAlert';
import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonIcon, IonInput, IonItem, IonLabel, IonList, IonLoading, IonModal, IonSearchbar, IonTitle, IonToast, useIonViewDidEnter } from '@ionic/react';
import { arrowBack, locationOutline, map } from 'ionicons/icons';
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { incluirProjeto, listaEquipePorPerfil, requestService } from '../../../../../Utils/Services';
import AppTypeaheadList from '../../../../../components/AppTypeaheadList';
import { useGooglePlacesSimple } from '../../../../../components/useGooglePlacesSimple';
import { MessageContext } from '../../../../../contexts/MessageContext';
import Endereco from '../Endereco/Endereco';
import './OrdensNovoProjeto.css';

type Props = {
  clienteid: any;
  inputRef: any;
  closeAction: Function;
  closeActionSimple: Function;
}

const OrdensNovoProjeto: React.FC<Props> = (props: Props) => {
  const history = useHistory();

  const { loja, setLoja } = useContext(MessageContext);
  const [lojas, setLojas] = useState<string>(loja);
  const { recarregarProjeto, setRecarregarProjeto } = useContext(MessageContext);
  const { pkUsuario, setPkUsuario } = useContext(MessageContext);
  const [textoFiltro, setTextoFiltro] = useState<any>();
  const [textToast, setTextToast] = useState("");
  const [showToast, setShowToast] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const [mostartAlerta] = useIonAlert();

  const [nomeProjeto, setNomeProjeto] = useState<any>();
  const [listaCliente, setListaCliente] = useState<any>([]);
  const [listaFiltrada, setListaFiltrada] = useState<any>([]);

  const [showModalResponsaveis, setShowModalResponsaveis] = useState(false);
  const [responsaveis, setResponsaveis] = useState<any>([]);
  const [selectedResponsaveis, setSelectedResponsaveis] = useState<any>([]);
  const [selectedResponsaveisText, setSelectedResponsaveisText] = useState<string>('0 Responsáveis');

  const [showDetalhesEndereco, setShowDetalhesEndereco] = useState(false);
  const inputRefEndereco = useRef<any>(null);

  const [focusAppTypeaheadItemClientes1, setFocusAppTypeaheadItemClientes1] = useState(false);

  const [pkCliente, setPkCliente] = useState("");
  const [nome, setNome] = useState("");
  // const [cpf, setCPF] = useState("");
  // const [email, setEmail] = useState("");
  const [telefone, setTelefone] = useState("");
  const [endereco, setEndereco] = useState("");
  const [enderecoLat, setEnderecoLat] = useState("");
  const [enderecoLng, setEnderecoLng] = useState("");
  const [complemento, setComplemento] = useState("");
  const [ignorarProximaMudanca, setIgnorarProximaMudanca] = useState(false);

  const campoTelefone = useRef<any>(null);

  // Hook do Google Places Simple
  const {
    listaEnderecos: listaEnderecosGoogle,
    buscandoEndereco: loadingEnderecos,
    buscarSugestoes: buscarSugestoesEndereco,
    buscarDetalhes: buscarDetalhesEndereco,
    limparSugestoes: limparSugestoesEndereco
  } = useGooglePlacesSimple({
    onError: (mensagem: string) => {
      setTextToast(mensagem);
      setShowToast(true);
    },
    onLoading: setShowLoading
  });

  useEffect(() => {
    // Define o foco no input quando o componente é montado
    if (props.inputRef.current) {
      props.inputRef.current.focus();
    }
  }, [props.inputRef]);

  useEffect(() => {

    setFocusAppTypeaheadItemClientes1(true);

    consultarUsuarios();

    buscarClientes();

  }, []);

  useIonViewDidEnter(() => {

  })

  // Função para buscar detalhes e preencher campos automaticamente
  const handleBuscarDetalhesEndereco = useCallback(async (placeId: string, enderecoFormatado: string) => {
    try {
      const detalhes = await buscarDetalhesEndereco(placeId, enderecoFormatado);
      if (detalhes && detalhes.sucesso) {
        setEndereco(detalhes.endereco);
        setEnderecoLat(detalhes.latitude.toString());
        setEnderecoLng(detalhes.longitude.toString());

        // Limpar sugestões após seleção
        limparSugestoesEndereco();
      }
    } catch (error) {
      console.error('Erro ao buscar detalhes do endereço:', error);
    }
  }, [buscarDetalhesEndereco, limparSugestoesEndereco]);

  // Função para lidar com seleção de item da lista de sugestões
  const handleSelectItemEndereco = useCallback((item: any) => {
    // Ativa flag para ignorar próxima mudança (evita busca automática)
    setIgnorarProximaMudanca(true);

    // Busca detalhes completos do endereço selecionado
    handleBuscarDetalhesEndereco(item.placeId, item.descricao);
  }, [handleBuscarDetalhesEndereco]);

  function validarCampos() {

    if (nome.length == 0) {
      setTextToast("Campo Nome é obrigatório.");
      setShowToast(true);
      return false;
    }
    else if (telefone.length != 15 && telefone.length != 14) {
      setTextToast("Campo Telefone é obrigatório.");
      setShowToast(true);
      return false;
    }
    else if (endereco.length == 0) {
      setTextToast("Campo Endereço é obrigatório.");
      setShowToast(true);
      return false;
    }

    // else if (enderecoLat.length == 0) {
    //   setTextToast("Selecione um endereço no mapa.");
    //   setShowToast(true);
    //   return false;
    // }
    // else if (enderecoLng.length == 0) {
    //   setTextToast("Selecione um endereço no mapa.");
    //   setShowToast(true);
    //   return false;
    // }
    return true;
  }

  function avancar(pularEndereco: boolean = false) {

    console.log("1");
    if (!validarCampos())
      return;

    console.log("2");

    setShowLoading(true);

    let objRequest = {
      "nomeProjeto": nomeProjeto,
      "nomeCliente": nome,
      "telefoneCliente": "55" + telefone.replace("(", "").replace(")", "").replace(" ", "").replace("-", ""),
      lojas: JSON.parse(window.localStorage.getItem("lojas") || "[]").filter((value: any) => {
        return lojas.includes(value.empresaLojaId);
      }),
      "pularEndereco": pularEndereco,
      "endereco": endereco || "",
      "complemento": complemento || "",
      "enderecoLat": enderecoLat,
      "enderecoLng": enderecoLng,
      "clienteid": pkCliente.replaceAll(/#/g, '%23'),
      "empresaid": loja || "",
      "responsaveis": selectedResponsaveis,
      "interno": false
    };

    console.log("objRequest", objRequest);

    requestService(incluirProjeto.url, {
      method: incluirProjeto.method,
      headers: [
        ["token", window.localStorage.getItem("token")]
      ],
      body: JSON.stringify(objRequest),
      credentials: 'include'
    },
      history,
      (response: any) => {
        if (response.message) {


          setTextToast((window.localStorage.getItem("servicoTipo") || "Projeto") + " criado com sucesso!");
          setShowToast(true);

          if (response.message?.pk) {
            props.closeAction(response.message?.pk);
            // history.push("ordens/ordensprodutos", { id: response.message?.pk.replaceAll(/#/g, "%23") })
          }
        }
      },
      (error: any) => {
        console.log(error);
        mostartAlerta({
          backdropDismiss: false,
          header: 'Endereço com problema',
          message: error.message,

          buttons: [{
            text: 'Cancelar',
            role: 'cancel',
          },
          {
            text: 'Confirmar',
            handler: () => {
              avancar(true);
            }
          }],
          onDidDismiss: () => { console.log('did dismiss'); }
        }).finally(() => {
          setShowLoading(false);
        });





      })



  }


  const formatData = (data: string[]) => {
    if (data.length === 1) {
      const responsavel = responsaveis.find((convidado: any) => convidado.pk === data[0])!;
      return responsavel.nome;
    }

    return `${data.length} Responsáveis`;
  };

  const responsavelSelectionChanged = (responsaveis: any[]) => {

    if (responsaveis.length > 0) {
      setSelectedResponsaveis(responsaveis);
      setSelectedResponsaveisText(formatData(responsaveis));
    }
    else {
      setSelectedResponsaveis([]);
      setSelectedResponsaveisText("0 Responsáveis");
    }
    setShowModalResponsaveis(false);
  };


  const buscarClientes = async () => {
    try {
      setShowLoading(true);
      let listaClientes = await buscarClientesDynamoDb();

      if (Array.isArray(listaClientes) && listaClientes.length > 0) {
        let lista = (listaClientes.sort((a: any, b: any) => (a.nome.toLowerCase() > b.nome.toLowerCase()) ? 1 : -1))

        console.log("lista", lista);
        setListaCliente(lista);

      }
    } catch (error: any) {
      console.error("Ocorreu um problema inesperado. Por favor, tente novamente mais tarde. Detalhes do erro: ", error);
      setTextToast(error);
      setShowToast(true);
    } finally {
      setShowLoading(false);
    }

  }

  const buscarClientesDynamoDb = async () => {

    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    let montarUrl = listaEquipePorPerfil.url.replace("{loja}", loja.replaceAll(/#/g, "%23")).concat("?status=ativo");

    const resp = await fetch(montarUrl.replace("{perfil}", "cliente"),
      {
        method: "GET",
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    let clientes = await resp.json();
    if (resp.status === 400 || resp.status === 401) {
      history.replace("/login/");
    }
    else {
      if (clientes.Items) {
        return clientes.Items;
      }
    }
  }

  const consultarUsuarios = async () => {

    let ret2 = await consultarUsuarioDynamoDb();
    console.log("ret2", ret2);

    let lista = (ret2.sort((a: any, b: any) => (a.nome.toLowerCase() > b.nome.toLowerCase()) ? 1 : -1))
    setResponsaveis(lista);

    const responsavelSelecionado = lista.find((convidado: any) => convidado.pk === pkUsuario);

    console.log("responsavelSelecionado", responsavelSelecionado);

    if (responsavelSelecionado) {
      setSelectedResponsaveis([responsavelSelecionado.pk]);
      setSelectedResponsaveisText(responsavelSelecionado.nome);
    }
  }


  const consultarUsuarioDynamoDb = async () => {

    let token: string = "";
    const tkn = localStorage.getItem("token");
    if (typeof (tkn) === "string") {
      token = tkn;
    }

    let montarUrl = listaEquipePorPerfil.url.replace("{loja}", loja.replaceAll(/#/g, "%23")).concat("?status=ativo");

    const resp = await fetch(montarUrl.replace("{perfil}", "usuario"),
      {
        method: "GET",
        headers: [
          ["token", token]
        ],
        credentials: 'include'
      });
    let equipe = await resp.json();
    if (resp.status === 400 || resp.status === 401) {
      history.replace("/login/");
    }
    else {
      if (equipe.Items) {
        return equipe.Items;
      }
    }
  }

  async function closeModalEndereco(enderecoSelecionado: any, latitudeSelecionado: any, enderecoLngSelecionado: any) {
    console.log("enderecoSelecionado", enderecoSelecionado);
    console.log("latitudeSelecionado", latitudeSelecionado);
    console.log("enderecoLngSelecionado", enderecoLngSelecionado);

    setEndereco(enderecoSelecionado);
    setEnderecoLat(latitudeSelecionado);
    setEnderecoLng(enderecoLngSelecionado);

    setShowDetalhesEndereco(false);
  }

  async function closeModalSimpleEndereco() {
    setShowDetalhesEndereco(false);
  }

  function onKeyUpTelefone(e: any) {

    e.persist();
    e.preventDefault();



    let val = e.target.value;

    if (val.length > 15) {
      val = val.substring(0, 15);
      setTelefone(val.substring(0, 15));
      return;
    }
    if (val.length < 15) {

      setTelefone(val
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{4})(\d)/, "$1-$2")
        .replace(/(-\d{4})(\d+?)$/, "$1"));
    }
    else {

      setTelefone(val
        .replace(/\D/g, "")
        .replace(/(\d{2})(\d)/, "($1) $2")
        .replace(/(\d{5})(\d)/, "$1-$2")
        .replace(/(-\d{4})(\d+?)$/, "$1"));
    }


  }

  function formatCPF(e: string) {
    let cpfval = e.replace(/\D/g, "")
    cpfval = cpfval.replace(/(\d{3})(\d)/, "$1.$2")
    cpfval = cpfval.replace(/(\d{3})(\d)/, "$1.$2")
    cpfval = cpfval.replace(/(\d{3})(\d{1,2})$/, "$1-$2")
    console.log(cpfval);
    return cpfval;
  }

  function formataTelefone(numero: any) {
    if (numero?.length == 13) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{5})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else if (numero?.length == 12) {
      let BRNumber = numero.replace("55", "").match(/(\d{2})(\d{4})(\d{4})/);
      BRNumber = "(" + BRNumber[1] + ") " + BRNumber[2] + "-" + BRNumber[3];
      return BRNumber;
    }
    else { return "" };
  }

  const handleSelectItem = (item: any) => {
    setListaFiltrada([]);
    setTextoFiltro("");

    setNome(item.nome);
    // setCPF(formatCPF(item.cpf));
    setTelefone(formataTelefone(item.telefone));
    setEndereco(item.endereco);
    setEnderecoLat(item.enderecoLat);
    setEnderecoLng(item.enderecoLng);
    setComplemento(item.complemento);
    setPkCliente(item.pk);
    // if (item.dataAniversario) {
    //   setDataAniversario(item.dataAniversario);
    //   setDataAniversarioBr(new Intl.DateTimeFormat('pt-BR', { timeZone: 'UTC' }).format(
    //     Date.parse(item.dataAniversario)
    //   ));
    // }
    console.log("item", item);
  };

  return (
    <>

      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonIcon slot="icon-only" icon={arrowBack} onClick={() => props.closeActionSimple()} />
          </IonButtons>
          <IonTitle>Criar {(window.localStorage.getItem("servicoTipo") || "Projeto")}</IonTitle>

        </IonToolbar>
        <div style={{ background: "var(--ion-color-primary)", padding: "0px", margin: "0px" }}>
          <IonSearchbar
            ref={(ref) => props.inputRef.current = ref}
            value={textoFiltro}
            onIonChange={(e) => {

              let lista = textoFiltro
                ? listaCliente.filter((value: any) =>
                  value.nome.toLowerCase().includes(textoFiltro?.toLowerCase())
                )
                : [];
              setListaFiltrada(lista);
              setTextoFiltro(e.detail.value)
            }}
            placeholder="Pesquisar nome"
          />
        </div>

        {listaFiltrada?.length > 0 && (
          <IonList style={{ position: 'absolute', zIndex: 999, backgroundColor: 'white', width: '100%', height: "auto", borderBottom: listaFiltrada.length > 0 ? '1px solid #f1f1f1' : 'none' }}>
            {listaFiltrada.map((item: any, index: any) => (
              <IonItem lines="none" key={"filtro" + index} button onClick={() => handleSelectItem(item)}>
                <IonLabel>{item.nome}</IonLabel>
              </IonItem>
            ))}
          </IonList>
        )}

      </IonHeader>
      <IonContent class="ion-padding">


        <IonList lines="full" class="ion-no-margin">

          <IonItem lines="none" hidden={(window.localStorage.getItem("identificacaoPorNumero") == "true") ? true : false}>
            <IonLabel>Nome</IonLabel>
            <IonInput placeholder={`Nome ${window.localStorage.getItem("servicoTipo") || "Projeto"}`} value={nomeProjeto}
              autoCorrect='true' autoCapitalize='true'
              required onIonInput={(e: any) => setNomeProjeto(e.target.value)}></IonInput>
          </IonItem>

          {/* <IonItem lines="none">
            <IonLabel>Cliente*</IonLabel>
            <IonButtons slot="end" onClick={() => { setShowCriarCliente(!showCriarCliente) }}>
              <IonIcon color="tertiary" size='large' slot="icon-only" icon={showCriarCliente ? removeCircle : addCircle}></IonIcon>
            </IonButtons>





          </IonItem> */}


          <IonItem lines="none">
            <IonLabel position="stacked">Nome*</IonLabel>
            <IonInput placeholder="Digite o nome completo" value={nome} autoCorrect='true' autoCapitalize='true' required onIonInput={(e: any) => setNome(e.target.value)}></IonInput>
          </IonItem>


          <IonItem lines="none">
            <IonLabel position="stacked">Telefone*</IonLabel>
            <IonInput ref={(ref) => campoTelefone.current = ref} type="tel" maxlength={15} placeholder="(__) _____-____" required value={telefone} onKeyUp={onKeyUpTelefone} />
          </IonItem>

          {/* <IonItem lines="none">
                  <IonLabel>Interno</IonLabel>
                  <IonToggle slot='end' checked={checkedInterno} onIonChange={e => {
                    setCheckedInterno(e.detail.checked);
                  }} />
                </IonItem> */}



          {/* <IonItem lines="none">
                  <IonLabel position="stacked">CPF</IonLabel>
                  <IonInput type="tel" maxlength={14} placeholder="___.___.___-__" required value={cpf} onKeyUp={onChangeCPF} />
                </IonItem>


                <IonItem lines="none">
                  <IonLabel position="stacked">E-mail</IonLabel>
                  <IonInput value={email} type='email' autoCorrect='true' placeholder="Digite o e-mail" onIonInput={(e: any) => setEmail(e.target.value)}></IonInput>
                </IonItem>

                <IonItem lines="none">
                  <IonLabel position="stacked">Aniversário</IonLabel>
                  <IonInput value={dataAniversarioBr} placeholder="Selecione" onClick={e => { openPopoverCad(e); }}></IonInput>
                </IonItem> */}


          <IonItem lines="none">
            <IonLabel position="stacked">Endereço*</IonLabel>
            <IonInput
              value={endereco}
              autoCorrect='true'
              autoCapitalize='true'
              placeholder="Avenida Paulista, 111, São Paulo"
              onIonInput={(e: any) => {
                const valor = e.target.value || "";
                setEndereco(valor);

                // Se flag estiver ativa, ignorar busca (foi preenchimento automático)
                if (ignorarProximaMudanca) {
                  setIgnorarProximaMudanca(false);
                  return;
                }

                // Buscar sugestões automaticamente
                buscarSugestoesEndereco(valor);
              }}
              onKeyDown={(e: any) => {
                // Enter força busca imediata
                if (e.key === "Enter") {
                  e.preventDefault();
                  const valor = endereco || '';
                  if (valor.trim().length >= 4) {
                    buscarSugestoesEndereco(valor, true);
                  } else {
                    setTextToast('Digite no mínimo 4 caracteres para buscar.');
                    setShowToast(true);
                  }
                }
              }}
            />
            <IonIcon slot="end" size="large" color="primary" icon={map} onClick={() => { setShowDetalhesEndereco(true); }} />

          </IonItem>

          {/* Lista de sugestões do Google Places */}
          {listaEnderecosGoogle?.length > 0 && (
            <IonItem lines="none" style={{ padding: '0px 0px' }}>
              <IonList
                style={{
                  padding: '0px',
                  width: '100%',
                  border: '1px solid #ddd',
                  borderRadius: '8px',
                  backgroundColor: '#fff',
                  maxHeight: '197px',
                  overflowY: 'auto',
                  boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
                }}
              >
                {listaEnderecosGoogle.map((item: any, index: any) => {
                  return (
                    <IonItem
                      lines={index < listaEnderecosGoogle.length - 1 ? "full" : "none"}
                      key={"sugestao" + index}
                      button
                      onClick={() => handleSelectItemEndereco(item)}
                    >
                      <IonIcon
                        icon={locationOutline}
                        slot="start"
                        color='primary'
                        style={{ fontSize: '20px', marginRight: '12px' }}
                      />
                      <IonLabel style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                        <div style={{ fontWeight: '600', fontSize: '15px', marginBottom: '4px', color: '#333' }}>
                          {item.descricaoPrincipal}
                        </div>
                        <div style={{ fontSize: '13px', color: '#999' }}>
                          {item.descricaoSecundaria}
                        </div>
                      </IonLabel>
                    </IonItem>
                  );
                })}
              </IonList>
            </IonItem>
          )}

          {/* <IonItem lines="none">
                    <IonButton slot="end" style={{ textAlign: 'right' }} onClick={() => { setShowDetalhesEndereco(true); }}>Mapa</IonButton>
                  </IonItem> */}
          {/* <IonItem lines="none">
                    <IonLabel>Latitude*</IonLabel>
                    <IonInput placeholder="Selecione a Latitude" value={latitude}
                      autoCorrect='true' autoCapitalize='true'
                      required onIonInput={(e: any) => setLatitude(e.target.value)}></IonInput>
                  </IonItem>
                  <IonItem lines="none">
                    <IonLabel>Longitude*</IonLabel>
                    <IonSelect value={longitude} placeholder="Selecione o Longitude" onIonChange={(e) => setLongitude(e.detail.value)}>
                      {longitudes.map((longitude) => (
                        <IonSelectOption key={longitude.sigla} value={longitude.sigla}>
                          {longitude.sigla}
                        </IonSelectOption>
                      ))}
                    </IonSelect>
                  </IonItem> */}
          <IonItem lines="full">
            <IonLabel>Complemento</IonLabel>
            <IonInput placeholder="Apartamento, bloco, etc." value={complemento}
              autoCorrect='true' autoCapitalize='true'
              required onIonInput={(e: any) => setComplemento(e.target.value)}></IonInput>
          </IonItem>

          <IonItem lines="none">
            <IonLabel>Responsáveis</IonLabel>
            <IonItem slot="end" lines="none" button={true} detail={false} onClick={e => { setShowModalResponsaveis(true); }}>
              {selectedResponsaveisText}
            </IonItem>
            <IonModal isOpen={showModalResponsaveis} onDidDismiss={() => setShowModalResponsaveis(false)} >
              <AppTypeaheadList
                title="Responsáveis"
                items={responsaveis}
                selectedItems={selectedResponsaveis}
                autoFocus={focusAppTypeaheadItemClientes1}
                onSelectionCancel={() => setShowModalResponsaveis(false)}
                onSelectionChange={responsavelSelectionChanged}
              />
            </IonModal>
          </IonItem>

        </IonList>

        <IonModal className="fullscreen-modal"
          onDidPresent={() => {
            if (inputRefEndereco.current) {
              inputRefEndereco.current.setFocus();
            }
          }} isOpen={showDetalhesEndereco} onDidDismiss={() => { setShowDetalhesEndereco(false); }}>
          <Endereco endereco={endereco} inputRef={inputRefEndereco} closeAction={closeModalEndereco} closeActionSimple={closeModalSimpleEndereco}></Endereco>
        </IonModal>



      </IonContent>
      <IonFooter className="ion-no-border" >
        <IonToolbar>
          <IonButton expand="block" size='large' color="primary" onClick={() => { avancar(); }}>Registrar</IonButton>
        </IonToolbar>
      </IonFooter>

      < IonToast
        isOpen={showToast}
        position="middle" //top, bottom, middle
        onDidDismiss={() => setShowToast(false)}
        message={textToast}
        duration={3000}
      />


      <IonLoading
        cssClass='my-custom-class'
        isOpen={showLoading}
        onDidDismiss={() => { setShowLoading(false); }}
        spinner='circles'
      />

    </>
  );
};

export default ({ clienteid, inputRef, closeAction, closeActionSimple }: { clienteid: any, inputRef: any, closeAction: Function, closeActionSimple: Function }) => (
  <OrdensNovoProjeto clienteid={clienteid} inputRef={inputRef} closeAction={closeAction} closeActionSimple={closeActionSimple}>
  </OrdensNovoProjeto>
)
